import { en } from './en';

export const ja = {
  ...en,
  home: 'ホーム',
  dashboard: 'ダッシュボード',
  reports: 'レポート',
  scans: 'スキャン',
  settings: '設定',
  profile: 'プロフィール',
  login: 'ログイン',
  signup: '新規登録',
  register: '登録',
  logout: 'ログアウト',
  upgrade: 'アップグレード',
  notifications: '通知',
  language: '言語',
  englishShort: 'EN',
  japanese: '日本語',
  japaneseNative: '日本語',
  toggleNavigationMenu: 'ナビゲーションメニューを切り替え',
  switchToJapanese: '日本語に切り替え',
  switchToEnglish: '英語に切り替え',
  fortexaLogoAlt: 'FORTEXA ロゴ',
  securityScanner: 'セキュリティスキャナー',
  securityScan: 'セキュリティスキャン',
  scanHistory: 'スキャン履歴',
  field: '項目',
  page: 'ページ',
  show: '表示',
  hide: '非表示',
  analyzing: '分析中...',
  securityDisclaimer: '認証情報は保存されず、スキャン中のみメモリ上で安全に処理されます',
  configureScan: 'スキャンを設定',
  enterCredentials: '認証情報の入力',
  verifyConfiguration: '設定を確認',
  detectedLoginForm: '検出されたログインフォーム',
  availableFields: '利用可能な項目:',
  submitButton: '送信ボタン',
  tip: 'ヒント:',
  loginSuccessful: 'ログインに成功しました！',
  credentialsVerified: '認証情報を確認しました。セッションCookieを取得しました。',
  loginFailed: 'ログインに失敗しました',
  couldNotAuthenticateProvidedCredentials: '入力された認証情報では認証できませんでした',
  authenticationVerified: '認証を確認しました',
  readyToStartAuthenticatedSecurityScan: '認証付きセキュリティスキャンを開始できます',
  targetLabel: '対象:',
  loginUrlLabel: 'ログインURL:',
  fieldsLabel: '項目数:',
  credentialFields: '件の認証情報項目',
  enter: '入力',
  selectFieldOption: '--- {label} を選択 ---',
  targetUrlHelp: '脆弱性を分析したい主対象のURLです',
  loginPageUrlHelp: 'ログインページのURLです（対象URLと同じでもかまいません）',
  detectionErrorLabel: '検出エラー:',
  enterTargetAndLoginUrls: 'スキャン対象のURLとログインページのURLを入力してください',
  authScanNoteTitle: '開始前にご確認ください — 制限事項',
  authScanNoteCaptcha: 'reCAPTCHA / CAPTCHA：ログインページにCAPTCHA認証が必要な場合、自動ログインは失敗します。スキャン前にCAPTCHAを一時的に無効化するか、CAPTCHAが適用されないテスト環境をご利用ください。',
  authScanNoteMFA: '二要素認証（2FA / MFA）：パスワード入力後にワンタイムコード（SMS・メール・認証アプリ）の入力が求められる場合、ツールはログインを完了できません。2FAを無効化したテスト用アカウントをご使用ください。',
  authScanNoteOAuth: 'ソーシャル / SSOログイン（Google、Microsoftなど）：標準的なユーザー名とパスワードのフォームログインのみ対応しています。「Googleでサインイン」などのボタンのみ提供されている場合、認証スキャンは利用できません。',
  authScanNoteWAF: 'IPブロック / ボット検知：一部のセキュリティシステムは自動リクエストをブロックする場合があります。スキャンが予期せず失敗する場合は、スキャンサーバーのIPアドレスを対象環境のホワイトリストに登録する必要があるかご確認ください。',
  scanComplete: 'スキャン完了',
  scanningInProgress: 'スキャン実行中',
  securityScanCompletedReviewBelow: 'セキュリティスキャンが完了しました。下記の結果をご確認ください。',
  runningAuthenticatedWebsiteScan: '認証済みWebサイトに対してすべてのセキュリティスキャナーを実行しています',
  fetchingPerformanceAndSecurityMetadata: 'パフォーマンスとセキュリティ情報を取得しています...',
  vulnerabilityAnalysisInProgress: '脆弱性分析: {phase} ({progress}%)...',
  startingComprehensiveVulnerabilityScan: '包括的な脆弱性スキャンを開始しています...',
  generatingAiPoweredSecurityInsights: 'AIによるセキュリティ分析を生成しています...',
  finalizingResults: '結果を仕上げています...',
  savingSchedule: '予約を保存しています...',
  scheduleCreatedSuccessfully: '予約を作成しました。',
  analysisComplete: '分析完了！',
  analysisFailed: '分析に失敗しました: {reason}',
  scanWasStopped: 'スキャンは停止されました',
  stoppingScan: 'スキャンを停止しています...',
  stoppingScanAndRestartingContainers: 'スキャンを停止し、コンテナを再起動しています...',
  scanStoppedContainersRestartingForFreshEnvironment: 'スキャンを停止しました。新しい環境のためコンテナを再起動しています',
  stopRequestSent: '停止リクエストを送信しました...',
  failedToStopScanWithReason: 'スキャンの停止に失敗しました: {reason}',
  scanRequestAccepted: 'スキャン要求を受け付けました...',
  initializingScan: 'スキャンを初期化しています...',
  analyzingTargetEnvironment: '対象環境を分析しています...',
  performingComprehensiveSiteAnalysis: '包括的なサイト分析を実行しています...',
  aiGeneratedAnalysisSummary: 'AI生成の分析サマリー',
  generatingAiAnalysisWaitingForAllScanData: 'AI分析を生成しています...（すべてのスキャンデータを待機中）',
  uploadProgress: 'アップロード中 {progress}%',
  scanning: 'スキャン中...',
  pending: '保留',
  valid: '有効',
  unavailable: '利用不可',
  headersPresent: 'ヘッダー有無',
  technologiesDetected: '検出された技術',
  noTechnologiesDetected: '技術は検出されませんでした',
  scanFailed: 'スキャン失敗',
  passed: '合格',
  starting: '開始中',
  notSet: '未設定',
  securityHeaders: 'セキュリティヘッダー',
  performance: 'パフォーマンス',
  outOf100: '100点満点',
  securityConfig: 'セキュリティ設定',
  malicious: '悪意あり',
  threatScore: '脅威スコア',
  sslCertificate: 'SSL証明書',
  unknownIssuer: '不明な発行元',
  techStack: '技術スタック',
  wafStatus: 'WAFステータス',
  scoreOf100: 'スコア: {score}/100',
  optimizationScore: '最適化スコア',
  mxRecordsFound: 'MXレコードを検出',
  noMailServer: 'メールサーバーなし',
  domainRegistered: 'ドメイン登録済み',
  enabled: '有効',
  disabled: '無効',
  preloaded: 'プリロード済み',
  notPreloaded: '未プリロード',
  clean: '正常',
  foundCount: '{count} 件検出',
  listsChecked: '{count} 件のリストを確認',
  green: 'グリーン',
  standard: '標準',
  hosting: 'ホスティング',
  notArchived: 'アーカイブなし',
  historicalSnapshots: '過去のスナップショット',
  timeout: 'タイムアウト',
  notFound: '見つかりません',
  urlsInSitemap: 'サイトマップ内のURL',
  complete: '完全',
  partial: '一部',
  missing: '未設定',
  linksFound: 'リンクを検出',
  redirectHops: 'リダイレクト数',
  serversFound: 'サーバーを検出',
  dnssecStatus: 'DNSSECステータス',
  securityPolicy: 'セキュリティポリシー',
  redirectTo: 'リダイレクト先:',
  tryDifferentSubmitButton: 'ログインに失敗した場合は、上のドロップダウンから別の送信ボタンを選んで再度お試しください。',
  selectLoginFieldsAndEnterCredentials: 'ログイン項目を選択し、認証情報を入力してください',
  reviewConfigurationAndStartAuthenticatedSecurityScan: '設定内容を確認し、認証付きセキュリティスキャンを開始してください',
  englishOnlyValidationFailed: '英語のみの検証に失敗しました',
  publicWebsiteScan: '公開Webサイトスキャン',
  authenticatedWebsiteScan: '認証付きWebサイトスキャン',
  chooseScanTypePrefix: 'スキャン種別を',
  chooseScanTypeHighlight: '選択',
  chooseScanTypeSubtitle: '実行するセキュリティスキャンの種類を選択してください',
  publicScanDescription: '公開されているWebサイト向けの包括的なセキュリティ分析です。詳細な脆弱性スキャン、パフォーマンス最適化チェック、セキュリティメタデータ分析を含みます。',
  authScanDescription: 'ログインで保護された領域向けの詳細なセキュリティ分析です。ログイン画面を自動検出し、認証情報を検証したうえで、認証済み領域を詳細にスキャンします。',
  comprehensiveVulnerabilityScan: '包括的な脆弱性スキャン',
  sitePerformanceAnalysis: 'サイトパフォーマンス分析',
  securityHeaderAnalysis: 'セキュリティヘッダー分析',
  websiteHealthCheck: 'Webサイト健全性チェック',
  noLoginRequired: 'ログイン不要',
  autoDetectLoginForms: 'ログインフォームの自動検出',
  credentialValidation: '認証情報の検証',
  inDepthAuthenticatedScan: '認証済み領域の詳細スキャン',
  cookieSessionManagement: 'Cookieベースのセッション管理',
  serverSideCredentialHandling: 'サーバー側での認証情報処理',
  scheduleScan: 'スキャンを予約',
  startPublicScan: '公開スキャンを開始',
  startAuthenticatedScan: '認証付きスキャンを開始',
  credentialsSecurityNote: '認証情報は保存されず、スキャン中のみメモリ上で安全に処理されます',
  heroTitle: 'ウェブサイト・ウェブアプリケーションのセキュリティリスクを可視化',
  scanNotice: 'スキャンはバックグラウンドで実行中です。完了時に通知します。このタブを閉じたりデバイスをオフにしても問題ありません。',
  enterUrlToStart: '開始するURLを入力',
  urlExample: 'https://example.com',
  analyzeUrl: 'URLを分析',
  startScan: 'スキャン開始',
  stopScan: 'スキャン停止',
  runningSecurityScans: 'セキュリティスキャンを実行しています...',
  resumingScan: 'スキャンを再開しています...',
  unknownError: '不明なエラー',
  noAnalysisId: 'レスポンスにanalysisIdがありません',
  stoppingScanRestarting: 'スキャンを停止し、コンテナを再起動しています...',
  scanStoppedRestarting: 'スキャンを停止しました。新しい環境のためコンテナを再起動しています',
  failedStopScan: 'スキャンの停止に失敗しました',
  enterUrlToScan: 'スキャンするURLを入力（例: https://example.com）',
  saveScheduledScan: '予約スキャンを保存',
  schedulingModeActive: '予約設定モードが有効です',
  settingUpPublicScan: '{date} {time} の公開スキャンを設定しています',
  settingUpAuthScan: '{date} {time} の認証付きスキャンを設定しています',
  loadingScanResults: 'スキャン結果を読み込んでいます...',
  combinedScanReport: '統合スキャンレポート',
  combinedScanReportTarget: '：{target}',
  websiteScreenshot: 'Webサイトのスクリーンショット',
  unableToLoadScan: 'スキャンを読み込めません',
  backToProfile: 'プロフィールに戻る',
  historicalScan: '過去のスキャン',
  scannedOn: 'スキャン日時',
  scanNotFound: 'スキャンが見つからないか、有効期限が切れています。スキャンは7日後に自動削除されます。',
  failedToLoadScan: 'スキャンの読み込みに失敗しました',
  failedToLoadScanTryAgain: 'スキャンの読み込みに失敗しました。もう一度お試しください。',
  loadingProfile: 'プロフィールを読み込んでいます...',
  sessionExpiredLoginAgain: 'セッションの有効期限が切れました。再度ログインしてください。',
  failedFetchProfile: 'プロフィールの取得に失敗しました',
  failedLoadProfile: 'プロフィールを読み込めませんでした。詳細はコンソールを確認してください。',
  failedUpdateProfile: 'プロフィールの更新に失敗しました',
  profileUpdated: 'プロフィールを更新しました。',
  myProfile: 'マイプロフィール',
  accountInformation: 'アカウント情報',
  editProfile: 'プロフィール編集',
  save: '保存',
  cancel: 'キャンセル',
  name: '名前',
  email: 'メールアドレス',
  password: 'パスワード',
  bio: '自己紹介',
  accountType: 'アカウント種別',
  memberSince: '登録日',
  lastLogin: '最終ログイン',
  noBioAdded: '自己紹介はまだ追加されていません',
  bioPlaceholder: '自己紹介を入力してください（最大500文字）',
  statistics: '統計',
  totalScans: '総スキャン数',
  thisMonth: '今月',
  dailyLimit: '1日の上限',
  maxFileSize: '最大ファイルサイズ',
  recentScans: '最近のスキャン',
  noScansYet: 'スキャンはまだありません。URLの分析から始めましょう。',
  scheduledScan: '予約スキャン',
  clickViewScanResults: 'クリックしてスキャン結果を表示（ステータス: {status}）',
  upgradeToPro: 'Proにアップグレード',
  choosePlan: 'プランを選択',
  unlockPremiumFeatures: 'プレミアム機能を利用できます:',
  unlimitedScans: '1日のスキャン数が無制限',
  largerFileLimit: 'ファイルサイズ上限の拡大（100MB）',
  priorityQueue: '優先スキャンキュー',
  advancedAnalyticsReports: '高度な分析レポート',
  apiAccessComingSoon: 'APIアクセス（近日提供予定）',
  selectPlan: 'プランを選択',
  startingCheckout: '決済ページに移動中...',
  checkoutFailed: '決済の開始に失敗しました。もう一度お試しください。',
  paymentProcessing: 'お支払いを確認しました。プランを有効化しています...',
  checkingPlanStatus: 'プラン状態を確認中...',
  refreshPlanStatus: '状態を更新',
  paymentPendingActivation: '決済は完了しましたが、有効化の同期中です。少し待ってから再読み込みしてください。',
  paymentSuccess: 'お支払いが完了しました！プランが有効になりました。',
  paymentCancelled: '決済がキャンセルされました。請求は発生していません。',
  currentPlanTitle: '現在のプラン',
  planStatus: 'ステータス',
  planStatusActive: '有効',
  planStatusPastDue: '支払い遅延',
  scansUsedLabel: '今月のスキャン使用数',
  seatsUsedLabel: '使用中のシート',
  teamManagement: 'チーム管理',
  emailAddress: 'メールアドレス',
  sendInvite: '招待を送信',
  activeMembers: 'アクティブメンバー',
  pendingInvites: '保留中の招待',
  revoke: '取り消す',
  revokeInvite: '招待を取り消す',
  inviteSentSuccess: '{email} に招待を送信しました',
  inviteEmailFailed: '招待は作成されましたが、メールを送信できませんでした。次のリンクを手動で共有してください: {link}',
  inviteRevokeFailed: '招待の取り消しに失敗しました',
  oneTimeScansRemaining: '残りスキャン数',
  planExpiresLabel: 'プラン有効期限',
  cancelSubscriptionNote: 'プランは現在の請求期間終了まで引き続き有効です。',
  subscriptionCancelled: 'サブスクリプションを解約しました。現在の請求期間終了まで利用できます。',
  proSubscription: 'Proサブスクリプション',
  proActiveUntil: 'Proサブスクリプションの有効期限:',
  cancelProReturnFree: 'Proを解約してFreeに戻す',
  upgradeNow: '今すぐアップグレード',
  cancelProSubscription: 'サブスクリプションを解約',
  downgradeConfirmMessage: 'サブスクリプションを解約しますか？現在の請求期間終了までご利用いただけます。',
  cancelSubscription: 'サブスクリプションを解約',
  keepPro: 'プランを継続',
  loginTitle: 'ログイン',
  loggingIn: 'ログイン中...',
  loginWithGoogle: 'Googleでログイン',
  googleLoginSuccessful: 'Googleログインに成功しました。リダイレクトしています...',
  googleLoginFailed: 'Googleログインに失敗しました。もう一度お試しください。',
  googleLoginFailedShort: 'Googleログインに失敗しました',
  loginFailedLater: 'ログインに失敗しました。しばらくしてからもう一度お試しください。',
  newUser: '初めてご利用ですか？',
  registerNow: '今すぐ登録',
  forgotPassword: 'パスワードをお忘れですか？',
  registerTitle: '登録',
  registering: '登録中...',
  signUpWithGoogle: 'Googleで登録',
  googleSignupSuccessful: 'Google登録に成功しました。リダイレクトしています...',
  googleSignupFailed: 'Google登録に失敗しました。もう一度お試しください。',
  googleSignupFailedShort: 'Google登録に失敗しました',
  registrationFailedLater: '登録に失敗しました。しばらくしてからもう一度お試しください。',
  haveAccount: 'すでにアカウントをお持ちですか？',
  logIn: 'ログイン',
  or: 'または',
  forgotPasswordDescription: 'メールアドレスを入力してください。パスワード再設定用リンクをお送りします。',
  sending: '送信中...',
  sendResetLink: '再設定リンクを送信',
  rememberPassword: 'パスワードを思い出しましたか？',
  resetPassword: 'パスワードをリセット',
  resetPasswordDescription: '新しいパスワードを入力してください。',
  newPassword: '新しいパスワード',
  confirmNewPassword: '新しいパスワードを確認',
  resetting: 'リセット中...',
  invalidResetLink: '無効なリセットリンクです',
  passwordsDoNotMatch: 'パスワードが一致しません',
  passwordMinLength: 'パスワードは6文字以上で入力してください',
  genericErrorLater: 'エラーが発生しました。しばらくしてからもう一度お試しください。',
  verifyEmail: 'メールアドレスの確認',
  otpSentTo: '6桁のコードを送信しました:',
  enterOtp: '6桁のコードを入力',
  verifying: '確認中...',
  verify: '確認',
  resendCode: 'コードを再送信',
  otpVerificationSuccess: '認証に成功しました。ようこそ。',
  verificationFailed: '認証に失敗しました。もう一度お試しください。',
  otpSentSuccess: 'OTPを送信しました。メールをご確認ください。',
  resendOtpFailed: 'OTPの再送信に失敗しました。もう一度お試しください。',
  wrongEmail: 'メールアドレスが違いますか？',
  goBackToLogin: 'ログインに戻る',
  scheduledScans: '予約スキャン',
  failedFetchSchedules: '予約の取得に失敗しました',
  failedDeleteSchedule: '予約の削除に失敗しました',
  failedTriggerScan: 'スキャンの実行に失敗しました',
  scheduledScansSubtitle: '単発および定期的なセキュリティスキャンを管理します',
  newSchedule: '+ 新規予約',
  activeSchedules: '有効な予約',
  loadingSchedules: '予約を読み込んでいます...',
  noScheduledScans: '予約スキャンはありません',
  noScheduledScansDescription: '最初の予約スキャンを作成して、対象へのセキュリティテストを自動実行しましょう。',
  goDashboardSchedule: 'ダッシュボードで予約する',
  sslStatus: 'SSLステータス',
  fetched: '取得済み',
  public: '公開',
  auth: '認証',
  recurring: '定期',
  oneTime: '単発',
  recurrence: '繰り返し',
  nextRun: '次回実行',
  lastRun: '前回実行',
  lastFailure: '前回の失敗: {reason}',
  runNow: '今すぐ実行',
  edit: '編集',
  delete: '削除',
  deleteSchedulePrompt: 'この予約を削除しますか？',
  yesDelete: 'はい、削除',
  scheduled: '予約済み',
  running: '実行中',
  completed: '完了',
  failed: '失敗',
  dayAtTime: '{days}日 {time}',
  notAvailable: '該当なし',
  scheduleAScan: 'スキャンを予約',
  editSchedule: '予約を編集',
  targetUrlReadOnly: '対象URL（読み取り専用）',
  scheduleMode: '予約モード',
  pickDateTime: '日時を選択',
  autoRepeat: '自動繰り返し',
  date: '日付',
  time: '時刻',
  selectDate: '日付を選択',
  today: '今日',
  selectedTime: '選択時刻: {time}',
  frequency: '頻度',
  twiceMonthly: '月2回',
  custom: 'カスタム',
  monthly: '毎月',
  daysOfMonth: '毎月の日付',
  executionTime: '実行時刻',
  processing: '処理中...',
  updateSchedule: '予約を更新',
  continueToConfig: '設定へ進む',
  pleaseLoginSchedule: 'スキャンを予約するにはログインしてください',
  pleaseSelectDateTime: '日付と時刻を選択してください',
  invalidDateTime: '日付または時刻が無効です',
  scheduledTimeFuture: '予約時刻は現在より後に設定してください',
  scheduledTimeWithinMonth: '予約時刻は現在から1か月以内に設定してください',
  pleaseSelectDay: '少なくとも1日を選択してください',
  configSavedRedirecting: '設定を保存しました。リダイレクトしています...',
  scheduleUpdated: '予約を更新しました。',
  scanScheduledSuccess: 'スキャンを予約しました。',
  failedSaveSchedule: '予約の保存に失敗しました',
  scanCompleted: 'スキャン完了',
  scanCompletedMessage: '{target} の {scanType} が正常に完了しました。',
  targetUrl: '対象URL',
  dismiss: '閉じる',
  viewReport: 'レポートを表示',
  configure: '設定',
  credentials: '認証情報',
  verifyStep: '確認',
  results: '結果',
  dismissError: '閉じる',
  targetWebsiteUrl: '対象WebサイトURL',
  loginPageUrl: 'ログインページURL',
  detectLoginFields: 'ログイン項目を検出',
  detecting: '検出中...',
  back: '戻る',
  continue: '続行',
  testLogin: 'ログインをテスト',
  testingLogin: 'ログインをテスト中...',
  startAuthenticatedSecurityScan: '認証付きセキュリティスキャンを開始',
  startNewScan: '新しいスキャンを開始',
  pleaseFillCredentials: 'すべての認証情報項目を入力してください',
  detectionFailed: '検出に失敗しました',
  couldNotAnalyzeLogin: 'ログインページを分析できませんでした',
  noLoginFormsDetected: 'このページでログインフォームを検出できませんでした。',
  loginTestFailed: 'ログインテストに失敗しました',
  sessionExpiredTestAgain: 'セッションの有効期限が切れました。ログインテストをやり直してください。',
  failedStartScan: 'スキャンの開始に失敗しました',
  failedGetScanStatus: 'スキャンステータスの取得に失敗しました',
  scanStoppedByUser: 'ユーザーによりスキャンが停止されました',
  selectLabel: '-- {label}を選択 --',
  aiSecurityReport: 'AIセキュリティレポート',
  findings: '検出事項',
  recommendations: '推奨事項',
  severity: '深刻度',
  vulnerabilityAnalysisResults: '脆弱性分析結果',
  alertTypes: 'アラート種別',
  totalOccurrences: '総発生件数',
  jsonReport: 'JSONレポート',
  pdfReport: 'PDFレポート',
  downloading: 'ダウンロード中...',
  generatingLang: '{lang}を生成中...',
  englishPdf: '英語PDF',
  japanesePdf: '日本語PDF',
  high: '高',
  medium: '中',
  low: '低',
  informational: '情報',
  occurrence: '件',
  occurrences: '件',
  description: '説明',
  solution: '対策',
  affectedUrls: '影響を受けるURL（{count}件表示{more}）',
  moreInFullReport: '、詳細は完全版レポートに記載',
  vulnerabilityAffectsUrls: 'この脆弱性は合計{count}件のURLに影響します。影響を受けるすべてのURLは完全版レポートで確認できます。',
  requestResponseEvidence: 'リクエスト / レスポンスの証跡',
  evidenceRequest: 'リクエスト',
  evidenceResponse: 'レスポンス',
  loadingEvidence: 'リクエスト/レスポンスデータを読み込み中…',
  noEvidenceCaptured: 'この項目の生のリクエスト/レスポンスは取得されていません。',
  showAllEvidence: 'すべての{count}件のリクエスト/レスポンスを表示',
  showLessEvidence: '表示を減らす',
  evidenceFullInJson: 'すべての発生箇所の完全なリクエスト/レスポンスはJSONレポートに含まれます。',
  noVulnerabilities: 'セキュリティ脆弱性は検出されませんでした。良好な状態です。',
  failedDownloadDetailedReport: '詳細レポートのダウンロードに失敗しました',
  failedDownloadPdfReport: 'PDFレポートのダウンロードに失敗しました: {message}',
  geminiKeyExhausted: 'PDF生成キーが上限に達しました',
  englishPdfOnly: '英語PDFには英語のみを含める必要があります',
  pdfDownloadFailed: 'PDFのダウンロードに失敗しました',
  downloadScanReports: 'スキャンレポートをダウンロード',
  downloadCompleteSecurityResults: '完全なセキュリティスキャン結果を希望の形式でダウンロードできます',
  generating: '生成中...',
  downloadPdfReport: 'PDFレポートをダウンロード',
  englishVersion: '英語版',
  japaneseVersion: '日本語版',
  downloadJsonData: 'JSONデータをダウンロード',
  initializingEnglishPdf: '英語PDFを初期化しています...',
  initializingJapanesePdf: '日本語PDFを初期化しています...',
  formattingScanData: 'スキャンデータを整形しています...',
  waitingRateLimit: 'APIレート制限を待機しています...',
  formattingAiAnalysis: 'AI分析を整形しています...',
  renderingPdfDocument: 'PDF文書をレンダリングしています...',
  finalizing: '最終処理中...',
  translatingToJapanese: '日本語レポートを準備しています...',
  downloadComplete: 'ダウンロードが完了しました。',
  failedDownloadReportTryAgain: 'レポートのダウンロードに失敗しました。もう一度お試しください。',
  pdfProgressNote: 'PDF生成ではレポートを整形します。最大2分ほどかかる場合があります。',
  downloadNote: 'PDF: 日英バイリンガルのプロフェッショナルレポート | JSON: 分析用の生データ',
  viewSiteHealthAnalysis: 'サイト健全性分析を表示（{count}コンポーネントを分析済み）',
  viewUrlscanAnalysis: 'URLScan.io分析を表示',
  urlscanSecurityVerdict: 'セキュリティ判定',
  urlscanOverall: '総合',
  urlscanThreatScore: '脅威スコア',
  urlscanUrlscanScore: 'URLScanスコア',
  urlscanEngineDetections: 'エンジン検出',
  urlscanCommunityScore: 'コミュニティスコア',
  urlscanMalicious: '悪意あり',
  urlscanClean: '安全',
  urlscanMaliciousCount: '{count}件の悪意ある検出',
  urlscanPageInformation: 'ページ情報',
  urlscanDomain: 'ドメイン',
  urlscanIpAddress: 'IPアドレス',
  urlscanCountry: '国',
  urlscanServer: 'サーバー',
  urlscanTlsIssuer: 'TLS発行者',
  urlscanTlsValidDays: 'TLS有効日数',
  urlscanNetworkStatistics: 'ネットワーク統計',
  urlscanHttpRequests: 'HTTPリクエスト数',
  urlscanUniqueIps: 'ユニークIP数',
  urlscanUniqueCountries: 'ユニーク国数',
  urlscanDataTransferred: '転送データ量',
  urlscanAllDataShown: 'このスキャンの脅威インテリジェンスおよびページ分析データはすべて上記に表示されています。',
  mozillaObservatorySecurityConfiguration: 'Mozilla Observatory セキュリティ設定',
  obsSecurityGrade: 'セキュリティグレード',
  obsScore: 'スコア',
  obsTestsPassed: 'テスト合格',
  obsTestsFailed: 'テスト不合格',
  obsGradeA: '優れたセキュリティ設定',
  obsGradeB: '概ね良好 — 軽微な不備あり',
  obsGradeC: '中程度のリスク — 複数のヘッダーが未設定',
  obsGradeD: '不十分な設定 — 重大な脆弱性リスク',
  obsGradeF: '危機的 — ほぼすべてのセキュリティヘッダーが未設定',
  obsRecommendedFixes: '推奨セキュリティヘッダーの修正',
  obsCspDesc: 'クロスサイトスクリプティング（XSS）およびデータインジェクション攻撃を防止',
  obsHstsDesc: 'HTTPSを強制し、SSLストリッピング攻撃を防止',
  obsXctoDesc: 'ドライブバイダウンロードを可能にするMIMEタイプスニッフィングをブロック',
  obsXfoDesc: '信頼されていないオリジンからのフレーム化をブロックしてクリックジャッキングを防止',
  obsRpDesc: 'サードパーティサイトへのリファラーデータ漏洩を制限',
  obsPpDesc: 'ブラウザ機能（カメラ、マイク、位置情報）へのアクセスを制限',
  obsNoData: 'このURLのセキュリティヘッダー分析データはありません。',
  sslCertificateDetails: 'SSL証明書の詳細',
  subject: 'サブジェクト',
  issuer: '発行者',
  validFrom: '有効開始日',
  validTo: '有効期限',
  serial: 'シリアル',
  validation: '検証',
  dnsRecords: 'DNSレコード',
  mxRecords: 'MXレコード',
  txtRecords: 'TXTレコード',
  found: '件検出',
  technologyStack: '技術スタック',
  openPorts: '開放ポート',
  open: '開放',
  noOpenPorts: '一般的な開放ポートは検出されませんでした',
  closedFilteredPorts: '閉鎖/フィルタ済みポート（{count}）',
  cookies: 'Cookie',
  headerCookies: 'ヘッダーCookie',
  clientCookies: 'クライアントCookie',
  viewHeaderCookies: 'ヘッダーCookieを表示（{count}）',
  viewClientCookies: 'クライアントCookieを表示（{count}）',
  whoisInformation: 'WHOIS情報',
  registrar: 'レジストラ',
  created: '作成日',
  expires: '有効期限',
  updated: '更新日',
  nameservers: 'ネームサーバー',
  domainStatus: 'ドメインステータス',
  mailConfiguration: 'メール設定',
  mailServices: 'メールサービス',
  noneDetected: '検出なし',
  mailTxtRecords: 'メールTXTレコード（{count}）',
  tlsSecurityAnalysis: 'TLSセキュリティ分析',
  grade: 'グレード',
  score: 'スコア',
  host: 'ホスト',
  socialMediaTags: 'ソーシャルメディアタグ',
  twitterCard: 'Twitterカード',
  themeColor: 'テーマカラー',
  redirectChain: 'リダイレクトチェーン',
  webArchiveHistory: 'Webアーカイブ履歴',
  totalSnapshots: '総スナップショット数',
  available: '利用可能',
  firstSnapshot: '最初のスナップショット',
  lastSnapshot: '最後のスナップショット',
  carbonFootprint: 'カーボンフットプリント',
  greenHosting: 'グリーンホスティング',
  yes: 'はい',
  no: 'いいえ',
  co2PerVisit: '訪問あたりCO2',
  cleanerThan: 'よりクリーン',
  ofSites: 'のサイト',
  robotsTxt: 'Robots.txt',
  noRobotsTxt: 'robots.txtファイルは見つかりませんでした',
  sitemap: 'サイトマップ',
  noSitemap: 'サイトマップは見つかりませんでした',
  urls: 'URL',
  viewSitemaps: 'サイトマップを表示（{count}）',
  viewUrls: 'URLを表示（{count}）',
  dnsServer: 'DNSサーバー',
  server: 'サーバー',
  provider: 'プロバイダー',
  country: '国',
  status: 'ステータス',
  enabledValid: '有効かつ正常',
  notEnabled: '未有効',
  algorithm: 'アルゴリズム',
  keyTag: 'キータグ',
  digestType: 'ダイジェスト種別',
  dsRecords: 'DSレコード',
  dnskeyRecords: 'DNSKEYレコード',
  websiteRanking: 'Webサイトランキング',
  trafficRank: 'トラフィック順位',
  notGlobalTop1m: 'グローバルトップ100万ドメインリストには見つかりませんでした。',
  httpStatus: 'HTTPステータス',
  responseTime: '応答時間',
  traceRoute: 'トレースルート',
  allHopsUnreachable: '全{count}ホップに到達できませんでした（ファイアウォールまたはCDNによりブロックされている可能性があります）。',
  unreachableHopsHidden: '到達不能なホップ{count}件を非表示',
  traceRouteDataAvailable: 'トレースルートデータを利用できます',
  ipAddress: 'IPアドレス',
  ip: 'IP',
  version: 'バージョン',
  location: '所在地',
  isp: 'ISP',
  organization: '組織',
  firewall: 'ファイアウォール',
  tlsGrade: 'TLSグレード',
  quality: '品質',
  mailConfig: 'メール設定',
  securityBlacklist: 'セキュリティブラックリスト',
  carbon: 'カーボン',
  archives: 'アーカイブ',
  socialTags: 'ソーシャルタグ',
  links: 'リンク',
  redirects: 'リダイレクト',
  rank: 'ランク',
  alertsCount: '{count} アラート',
  alertsCountPartial: '{count} アラート（一部）',
  crawlerRules: 'クローラールール',
  globalRank: 'グローバルランク',
  qualityMetrics: '品質指標',
  overall: '全体',
  accessibility: 'アクセシビリティ',
  bestPractices: 'ベストプラクティス',
  loadingExperience: '読み込み体験',
  qualityDataAvailable: '品質データを利用できます',
  // WebCheck detail labels
  subjectAltNames: 'サブジェクト代替名（{count}）',
  sha256Label: 'SHA-256',
  httpHeaders: 'HTTPヘッダー',
  firewallWafDetection: 'ファイアウォール / WAF検出',
  wafDetected: 'WAF検出',
  notDetected: '未検出',
  wafNameLabel: '名称',
  confidence: '信頼度',
  hstsFullTitle: 'HSTS（HTTP Strict Transport Security）',
  maxAge: '最大有効期間',
  includeSubdomains: 'サブドメインを含む',
  seconds: '秒',
  days: '日',
  securityTxtTitle: 'Security.txt',
  noSecurityTxtFound: 'security.txtファイルは見つかりませんでした',
  contactLabel: '連絡先',
  languagesLabel: '言語',
  canonicalLabel: '正規URL',
  viewFullSecurityTxt: 'security.txtの全文を表示',
  blockLists: 'ブロックリスト',
  listedOnBlocklists: '{count}件のブロックリストに登録されています',
  notListedOnBlocklists: 'いずれのブロックリストにも登録されていません',
  cleanOnLists: '{count}件のリストでクリーン',
  blockListDataAvailable: 'ブロックリストデータが利用可能です',
  blockedLabel: 'ブロック済み',
  linkedPages: 'リンクページ',
  internalLinks: '内部リンク',
  externalLinks: '外部リンク',
  viewInternalLinks: '内部リンクを表示（{count}）',
  viewExternalLinks: '外部リンクを表示（{count}）',
  urlLabel: 'URL',
  dnsServerInfoAvailable: 'DNSサーバー情報が利用可能です',
  dnssecTitle: 'DNSSEC',
  hopLabel: 'ホップ',
  rttLabel: 'RTT',
  ogTitleLabel: 'OGタイトル',
  ogDescriptionLabel: 'OG説明文',
  ogImageLabel: 'OG画像',
  serverN: 'サーバー {n}',
  priorityLabel: '優先度',
  // ZapReportEnhanced labels
  translatingVulnerabilityData: '脆弱性データを日本語に翻訳中...',
};
